module.exports = function(PluginManager) {
  PluginManager.registerVisitorProfileProvider(require('./providers/first_session'));
  PluginManager.registerAudienceMatcher('first_session', require('./matchers/first_session'));
};
